import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';

export const StartDateInfoActionSheet = () => (
  <ActionSheetV2 title="Why we ask for your start date">
    <LgPadding topPadding={SPACING.STATIC.NONE}>
      <Body>
        Knowing your start date helps us keep track of where you are on the medication journey and stay on top of your
        refill needs. It has no impact on your delivery date — you'll be able to select the date that works best for
        you.
      </Body>
    </LgPadding>
  </ActionSheetV2>
);
